// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
        // 传递参数
        params: {},
        // 组件路径
        rendertpl: null,
        // 跳转路由
        pathName: null,
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    this.pathName = this.$route.path.replace(/\//g, "");
    this.rendertpl = this.fun_Loadertpl(this.pathName);
  },
  // 自定义方法
  methods: {
    /**
     * 加载本地文件
     * @author 滕威
     */
    fun_Loadertpl(pathName) {
        // 如果是详情
        if (pathName.indexOf("Details") !== -1) {
            // 截取字符串
            const path = this.pathName = pathName.match(/(\S*)Details/)[1];
            // 切换详情
            return function (resolve) {
                require(["./" + path + "/details/index.vue"], resolve).default;
            };
        } else {
            this.pathName = pathName;
            // 一览
            return function (resolve) {
                require(["./" + pathName + "/index.vue"], resolve).default;
            };
        }
      },
     /**
     * 跳转详情页面
     * @author 滕威
     */
     fun_Details(path, params) {
        // 获取页面类型
        this.params = params;
        // 加载本地文件
        this.rendertpl = this.fun_Loadertpl(path);
      },
      /**
       * 返回上一页
       * @author 滕威
       */
      fun_Back() {
        // 路径
        const path = this.pathName;
        //加载本地文件
        this.rendertpl = this.fun_Loadertpl(path);
      }
  }
};
